import { IContextSession, IPermissions } from '../../initialStates/session/session';
import { RootState } from '../../store';

export const selectPermissions = (state: RootState): IPermissions => state.session.permissions;
export const selectContextSession = (state: RootState): IContextSession => state.session.contextSession;